import { useState, useEffect } from "react";

interface IProps {
  itemClassName?: string;
  contentEditable: boolean;
  formatItem: string;
  onInput: (e: React.ChangeEvent<HTMLDivElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  onCompositionStart: () => void;
  onCompositionEnd: (e: React.CompositionEvent<HTMLDivElement>) => void;
}
const BackTraceItem: React.FC<IProps> = ({
  contentEditable,
  formatItem,
  onInput,
  onKeyDown,
  onCompositionStart,
  onCompositionEnd,
}) => {
  const [showContent, setShowContent] = useState(formatItem);
  const [isFocus, setFocus] = useState(false);

  useEffect(() => {
    if (!isFocus) {
      setShowContent(formatItem);
    }
  }, [isFocus, formatItem]);

  const onFocus = () => {
    setFocus(true);
  };

  const onBlur = () => {
    setFocus(false);
  };

  return (
    <span
      className={`px-2 lh-5.5 text-3.5 color-#30343C focus:outline-none`}
      contentEditable={contentEditable}
      onInput={onInput}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      onCompositionStart={onCompositionStart}
      onCompositionEnd={onCompositionEnd}
    >
      {showContent}
    </span>
  );
};

export default BackTraceItem;
